/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ShivaWebPublicConfiguration {
  rootUrl: string = 'http://dataservices.ineotinea-gdfsuez.com:8090/web';
}

/**
 * Parameters for `ShivaWebPublicModule.forRoot()`
 */
export interface ShivaWebPublicConfigurationParams {
  rootUrl?: string;
}
